import { object, string } from 'yup';

export const dadosBancariosSchema = object({
  id: string(),
  banco: string().required(
    'Atenção, Conta no Banco Santander é obrigatória, exceto para residentes em cidades que não possuem agências do Banco Santander (neste caso, a agência da conta informada deverá ser na mesma cidade de residência)'
  ),
  agencia: string()
    .matches(/^\d{4}$/, 'Atenção, informe exatamente 4 dígitos numéricos.')
    .required('Atenção, informe a agência'),
  conta: string().when('banco', {
    is: '033',
    then: (field) =>
      field
        .length(
          8,
          'O número da conta Santander encontra-se no formato inválido. Favor inserir oito números conforme exemplo: 99999999.'
        )
        .test({
          name: 'isNumber',
          exclusive: true,
          message: 'Atenção, o número da conta deve ser um número válido.',
          // eslint-disable-next-line no-restricted-globals
          test: (value) => !isNaN(value),
        })
        .required('Para continuar, preencha os dados da Conta.'),
    otherwise: (field) =>
      field
        .test({
          name: 'isNumber',
          exclusive: true,
          message: 'Atenção, o número da conta deve ser um número válido.',
          // eslint-disable-next-line no-restricted-globals
          test: (value) => !isNaN(value),
        })
        .required('Para continuar, preencha os dados da Conta.'),
  }),
  digito: string()
    .required('Atenção, o dígito verificador da conta é obrigatório')
    .length(1, 'Atenção, o dígito verificador é limitado a um caracter'),
});

export class DadosBancariosModel {
  id = '';

  banco = '';

  agencia = '';

  conta = '';

  digito = '';
}
